import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 16px;;

  h6 {
    font-size: 24px;
    font-weight: bold;
  }
`;
